import axiosInstance from "../../../../axios/axios";

/**
 * Fetch My Semen Doses / Ownership Certificates
 * Endpoint: /api/SemenCollectionCertificate/GetMySemenDoses
 *
 * @param {Object} params
 * @param {string} [params.status=""] - Filter by status (e.g. 'Active', 'Used', or empty for all)
 * @param {string} [params.searchTerm=""] - Search term (stallion name, reg no, ref no)
 * @param {number} [params.pageNumber=1] - 1-based page number
 * @param {number} [params.pageNumbers=1] - 1-based page number (alias for compatibility)
 * @param {number} [params.pageSize=10] - Number of items per page
 * @returns {Promise<Object>} API response data
 */
export const fetchMySemenDosesApi = async ({
    status = "",
    searchTerm = "",
    pageNumber = 1,
    pageNumbers = 1,
    pageSize = 10,
} = {}) => {
    const page = pageNumber || pageNumbers || 1;
    const params = {
        pageNumber: page,
        pageNumbers: page,
        pageSize,
    };

    if (status && status !== "all") {
        params.status = status;
    }

    if (searchTerm && searchTerm.trim()) {
        params.searchTerm = searchTerm.trim();
    }

    const response = await axiosInstance.get(
        "/SemenCollectionCertificate/GetMySemenDoses",
        { params }
    );
    return response?.data;
};
